"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.version = void 0;
const version = "abi/5.0.0-beta.153";
exports.version = version;